import React from "react";
import { Tag } from "antd";
import { AICC_LANGUAGE_STATUS_COLOR, AICC_LANGUAGE_STATUS_LABEL, AiccLanguageStatus } from "constants/aiccLanguage";
import styles from "./LanguageStatusTag.module.scss";

interface Props {
  languageName?: string;
  status?: AiccLanguageStatus;
}

function LanguageStatusTag({ languageName, status }: Props) {
  if (!languageName) {
    return null;
  }

  return (
    <Tag
      className={styles.languageTag}
      style={status ? { backgroundColor: AICC_LANGUAGE_STATUS_COLOR[status] } : undefined}
    >
      {status ? `${languageName} · ${AICC_LANGUAGE_STATUS_LABEL[status]}` : languageName}
    </Tag>
  );
}

export default LanguageStatusTag;
